import {
  AfterViewInit,
  Component,
  ElementRef,
  Inject,
  Input,
  OnDestroy,
  OnInit,
  PLATFORM_ID,
  Renderer2,
  ViewChild,
  ViewEncapsulation
} from '@angular/core';
import { reviewsListMock } from '@App/modules/affiliate-flow/mock/affiliate-invite.mock';
import { CommonModule, NgForOf, isPlatformBrowser } from '@angular/common';

@Component({
  selector: 'app-review-list',
  imports: [CommonModule, NgForOf],
  templateUrl: './review-list.component.html',
  styleUrls: ['./review-list.component.scss'],
  standalone: true,
  encapsulation: ViewEncapsulation.None
})
export class ReviewListComponent implements OnInit, AfterViewInit, OnDestroy {
  @Input() reviews: any[] = reviewsListMock;
  @ViewChild('scrollContainer', { static: true }) scrollContainer: ElementRef;
  @ViewChild('reviewList', { static: true }) reviewList: ElementRef;

  extendedReviews = [];

  constructor(
    private renderer: Renderer2,
    @Inject(PLATFORM_ID) private platformId: any
  ) {}

  ngOnInit(): void {}

  ngAfterViewInit(): void {
    this.startScroll();
  }

  startScroll() {
    if (!isPlatformBrowser(this.platformId)) {
      return;
    }

    const reviewsContainer = this.reviewList.nativeElement;
    const reviewElements = Array.from(reviewsContainer.children);
    let scrollPosition = 0;

    // Clone reviews to achieve infinite scroll effect
    reviewElements.forEach((review: any) => {
      const clone = review.cloneNode(true);
      this.renderer.appendChild(reviewsContainer, clone);
    });

    const scroll = () => {
      scrollPosition -= 0.3; // Adjust this value to change the speed
      if (scrollPosition <= -reviewsContainer.scrollWidth / 2) {
        scrollPosition = 0;
      }
      reviewsContainer.style.transform = `translateX(${scrollPosition}px)`;
      requestAnimationFrame(scroll);
    };

    requestAnimationFrame(scroll);
  }

  ngOnDestroy(): void {
    // Cleanup code if needed
  }
}
